export default __webpack_public_path__ + "static/screen_history@2x-3846b7e987ee8e4345fe099c46902c8e.webp";